import { createStyles } from '@material-ui/core/styles';

export const mfa_styles = createStyles(theme => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f5f5f5'
    },
    dialog: {
        '& .MuiDialog-paper': {
            margin: 0,
            borderRadius: 0,
            [theme.breakpoints.up('sm')]: {
                borderRadius: 8,
                margin: 16
            }
        }
    },
    paper: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        maxWidth: 400,
        minHeight: '100vh',
        [theme.breakpoints.up('sm')]: {
            minHeight: 'auto'
        }
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        padding: theme.spacing(3),
        [theme.breakpoints.up('sm')]: {
            padding: theme.spacing(4)
        }
    },
    logoContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: theme.spacing(4)
    },
    logo: {
        width: 260,
        height: 'auto',
        [theme.breakpoints.down('xs')]: {
            width: 160
        }
    },
    formContainer: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
    },
    title: {
        fontSize: 24,
        fontWeight: 600,
        textAlign: 'center',
        marginBottom: theme.spacing(2),
        color: '#333'
    },
    description: {
        fontSize: 14,
        textAlign: 'center',
        marginBottom: theme.spacing(4),
        color: '#666',
        lineHeight: 1.5
    },
    input: {
        marginBottom: theme.spacing(3),
        width: '100%'
    },
    inputError: {
        marginBottom: theme.spacing(3),
        width: '100%',
        '& .MuiInputBase-root': {
            borderColor: '#d32f2f',
            '& fieldset': {
                borderColor: '#d32f2f',
            },
            '&:hover fieldset': {
                borderColor: '#d32f2f',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#d32f2f',
            }
        },
        '& .MuiInputLabel-root': {
            color: '#d32f2f',
            '&.Mui-focused': {
                color: '#d32f2f',
            }
        }
    },
    backLink: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: theme.spacing(3)
    },
    backButton: {
        background: 'none',
        border: 'none',
        color: '#007bff',
        cursor: 'pointer',
        fontSize: 14,
        textDecoration: 'underline',
        padding: 0,
        '&:hover': {
            color: '#0056b3'
        }
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
    },
    error: {
        color: '#d32f2f',
        fontSize: 14,
        textAlign: 'center',
        marginBottom: theme.spacing(2),
        padding: theme.spacing(1),
        backgroundColor: '#ffebee',
        borderRadius: 4,
        border: '1px solid #d32f2f',
        fontWeight: 500
    },
    submitButton: {
        marginTop: theme.spacing(2),
        height: 48,
        fontSize: 16,
        fontWeight: 600,
        textTransform: 'none'
    },
    resendButton: {
        marginTop: theme.spacing(1),
        height: 48,
        fontSize: 16,
        fontWeight: 600,
        textTransform: 'none'
    }
})); 